import { Namespace } from '../../translation/namespace';
import { VersionState } from '../../types/api/VersionState';
import { HeadMetaInfo } from '../../types/api/HeadMetaInfo';
import { EditModeInfo } from '../../types/api/EditModeInfo';
import i18next from '../../translation/i18n';

type getPageTitle = {
  headMetaInfo: HeadMetaInfo;
  editModeInfo: EditModeInfo;
  searchQuery?: string;
};

const getQParamFromSearchQuery = (searchQuery?: string) => {
  const query = searchQuery?.includes('?') ? searchQuery.split('?')[1] : searchQuery;
  return new URLSearchParams(query).get('q');
};

// See PageLeadMetaInfo.tsx as well for corresponding <h1>!
export function getPageTitle({ headMetaInfo, editModeInfo, searchQuery }: getPageTitle) {
  const { t } = i18next;
  let pageTitle = '';
  const qParam = getQParamFromSearchQuery(searchQuery);
  if (headMetaInfo) {
    pageTitle += `${headMetaInfo.title}`;
  }

  if (qParam) {
    pageTitle += ` ${t(`${Namespace.glossary}:by`)} "${qParam}"`;
  }

  if (editModeInfo.active) {
    pageTitle += ` - ${t(`${Namespace.glossary}:editMode`)}`;
  } else if (headMetaInfo.versionState === VersionState.draft) {
    pageTitle += ` - ${t(`${Namespace.glossary}:draft`)}`;
  } else if (headMetaInfo.versionState === VersionState.template) {
    pageTitle += ` - ${t(`${Namespace.glossary}:template`)}`;
  } else if (headMetaInfo.versionState === VersionState.publishedHistory) {
    pageTitle += ` - ${t(`${Namespace.glossary}:publishedHistory`)}`;
  } else if (headMetaInfo.pagination) {
    pageTitle += ` - ${t(`${Namespace.glossary}:page`)} ${headMetaInfo.pagination.currentPage} ${t(
      `${Namespace.glossary}:outOf`
    )} ${headMetaInfo.pagination.totalPages}`;
  }

  if (headMetaInfo) {
    pageTitle += ` - ${headMetaInfo.portalTitle}`;
  }

  return pageTitle;
}
